
export default function ClientDetailsPage() {
  return (
    <div>ClientDetailsPage</div>
  )
}
